import React from "react";
import { Linkedin, Instagram, Twitter } from "lucide-react";

/**
 * E-E-A-T author byline card — renders on guide/article pages when an
 * Author entity matches the post's author string. Shows bio, role, and
 * social profile links (LinkedIn, Instagram, Twitter) for trust signals.
 */
export default function AuthorProfile({ author }) {
  if (!author) return null;

  const hasSocial =
    author.linkedin_url || author.instagram_url || author.twitter_url;

  return (
    <div className="mt-12 pt-8 border-t border-border">
      <div className="flex items-start gap-4">
        {author.profile_image_url && (
          <img
            src={author.profile_image_url}
            alt={author.name}
            className="w-16 h-16 rounded-full object-cover flex-shrink-0 border border-border"
          />
        )}
        <div className="flex-1 min-w-0">
          <p className="font-mono text-xs uppercase tracking-widest text-steel mb-1">
            Written by
          </p>
          <div className="flex items-center gap-2 flex-wrap">
            <p className="font-heading text-bone text-lg font-bold">
              {author.name}
            </p>
            {author.title && (
              <span className="text-xs text-steel">— {author.title}</span>
            )}
          </div>
          {author.bio && (
            <p className="text-sm text-steel leading-relaxed mt-2">
              {author.bio}
            </p>
          )}
          {hasSocial && (
            <div className="flex items-center gap-3 mt-3">
              {author.linkedin_url && (
                <a
                  href={author.linkedin_url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-1.5 text-xs text-steel hover:text-cobalt transition-colors"
                  aria-label={`${author.name} on LinkedIn`}
                >
                  <Linkedin className="w-4 h-4" />
                  LinkedIn
                </a>
              )}
              {author.instagram_url && (
                <a
                  href={author.instagram_url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-1.5 text-xs text-steel hover:text-cobalt transition-colors"
                  aria-label={`${author.name} on Instagram`}
                >
                  <Instagram className="w-4 h-4" />
                  Instagram
                </a>
              )}
              {author.twitter_url && (
                <a
                  href={author.twitter_url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-1.5 text-xs text-steel hover:text-cobalt transition-colors"
                  aria-label={`${author.name} on Twitter`}
                >
                  <Twitter className="w-4 h-4" />
                  Twitter
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}